"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscriptionQuery = void 0;
const schema_1 = require("../schema");
const subscriptionQuery = (collection) => {
    const table = collection.metadata;
    const title = schema_1.metadataName(table);
    const now = new Date(Date.now()).toUTCString();
    const arrayRels = table.relationships
        .filter(rel => rel.rel_type === 'array')
        .map(rel => rel.rel_name);
    const fields = [
        collection.schema.primaryPath,
        'updated_at',
        ...arrayRels.map(rel => `${rel} { id updated_at }
    ${rel}_aggregate { aggregate { max { updated_at } count } }`)
    ].join(' ');
    const orConditions = [
        `{ updated_at: { _gt: "${now}" }}`,
        ...arrayRels.map(rel => `{${rel}: { updated_at: { _gt: "${now}" } } }`)
    ].join('\n');
    return `subscription on${title} {
    ${title} (
        where: {
            _or: [${orConditions}]
        }
        order_by: { updated_at: asc }
    ){ ${fields} }
}`;
};
exports.subscriptionQuery = subscriptionQuery;
//# sourceMappingURL=subscribe.js.map